export const walk_en = {
  'has_shared_walk_message' : ' has shared a walk with you!',
  'give_walk_review' : 'Give the walk a review',
  'person_has_booked_walk' : ' has booked this walk',
  'you_cancel_button' : 'Cancel the walk',
  'other_cancel_button' : 'Cancel the walk',
  'change_walk_button' : 'Edit the walk',
  'walk_already_booked' : 'The walk is already booked',
  'book_walk_button' : 'Book the walk',
  'no_longer_able_question' : 'Are you no longer able to attend the walk? Click below to cancel it.',
  'cancel_walk_confirmation' : 'Cancel confirmation',
  'the_walk_is_booked' : 'The walk is booked',
  'added_to_cal' : 'Added to calendar',
  'invitation' : 'Invitation',
  'private' : 'Private',
  'invited_persons' : 'Invited people:',

  'private_notes' : 'Private notes',
  'notes' : 'Notes',
  'card_edited' : 'The note is being edited...',
  'add_agenda' : 'Add item',
  'add_subject' : 'Add subject',
  'add_private' : 'Add private',
  'share_notes' : 'Share notes',
  'send_notes_email' : 'Send as email',
  'copy_notes' : 'Copy notes',
  'text_copied' : 'The text has been copied',
  'note_edit_not_allowed' : 'You cannot edit or delete another persons note.',
  
  'map' : 'Map',
  'something_wrong' : 'Something went wrong',
  'log_in_or_create' : 'Log in or create and account to read, create or edit notes.',
  'enter_room' : 'Enter room',
  'leave_room' : 'Leave room',
  'person_in_meeting' : ' person in the room',

  'enter_text' : 'Enter text',
  'share_note' : 'Share note',

  'certain_delete' : 'Are you certain you wish to delete the note?',
  'edit_agenda' : 'Edit agenda',
  'edit' : 'Edit',
  'delete' : 'Delete'
}